import React, { useEffect, useState } from 'react'
import { Box, Paper } from '@mui/material'

import { useAuth } from '../../components/AuthContext/AuthProvider'
import { AccountRecoveryRequest } from '../../components/AuthContext/types'
import { useNavigate } from 'react-router-dom'
import { APP_PATHS } from '../../components/AppRouter/types'
import { MainPageBox } from '../../components/DisplayHelpers/MainPageBox'
import ForgotPasswordComponent from './ForgotPassword.component'
import ChangePasswordComponent from './ChangePassword.component'
import {
  sendTrackingEvent,
  toButtonEvent,
  toScreenEvent
} from '../../services/amplitude.service'
import { RecoveryButtonEvent, ScreenOpendedEvent } from './types'

const ForgotPasswordContainer: React.FC = (): JSX.Element => {
  const [recoveryData, setRecoveryData] =
    useState<AccountRecoveryRequest | null>(null)
  const { loading, user, requestResetPassword, resetPassword } = useAuth()
  const navigate = useNavigate()

  sendTrackingEvent(toScreenEvent(ScreenOpendedEvent))

  const [isPasswordChangeInitiated, setIsPasswordChangeInitiated] =
    useState(false)

  const handleOnSubmitRequestReset = (data: AccountRecoveryRequest) => {
    sendTrackingEvent(toButtonEvent({ ...RecoveryButtonEvent }))
    setRecoveryData(data)
    requestResetPassword(data).then(() => setIsPasswordChangeInitiated(true))
  }

  const handleOnSubmitNewPassword = ({
    code,
    password
  }: {
    code: string
    password: string
  }) => {
    if (!recoveryData) return
    const { email } = recoveryData

    resetPassword({ code, email, password }).then(() => {
      navigate(APP_PATHS.LOGIN_IN)
    })
  }

  useEffect(() => {
    if (user && !loading) {
      navigate(APP_PATHS.APPLICATION, { replace: true })
    }
  }, [user])

  return (
    <MainPageBox>
      <Paper
        elevation={2}
        sx={{
          maxWidth: 600,
          minWidth: 300,
          pb: 2.5
        }}
      >
        <Box sx={{ p: 5 }}>
          {isPasswordChangeInitiated ? (
            <ChangePasswordComponent onSubmit={handleOnSubmitNewPassword} />
          ) : (
            <ForgotPasswordComponent
              onSubmit={handleOnSubmitRequestReset}
              loading={loading}
            />
          )}
        </Box>
      </Paper>
    </MainPageBox>
  )
}

export default ForgotPasswordContainer
